import { ArrowUp } from "lucide-react";
import { scrollToHash } from "@/components/Navbar";
import { useLanguage } from "@/lib/i18n";

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="border-t border-white/10 pt-20 pb-10 overflow-hidden" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row justify-between gap-12 mb-20">
          <div className="max-w-sm">
            <div className="mb-6">
              <img src="/fenrion-logo.png" alt="Fenrion AI" className="h-16 w-auto mix-blend-screen" data-testid="footer-logo" />
            </div>
            <p className="text-neutral-500 text-sm leading-relaxed">
              {t("footer.tagline")}
            </p>
          </div>
          <div className="flex gap-16 md:gap-24">
            <div>
              <p className="text-xs uppercase tracking-widest text-neutral-500 mb-5">{t("footer.services")}</p>
              <ul className="space-y-3 text-sm text-neutral-400">
                <li><a href="#services" onClick={scrollToHash("#services")} className="hover:text-[#FF5A00] transition-colors" data-testid="footer-link-websites">{t("footer.websites")}</a></li>
                <li><a href="#services" onClick={scrollToHash("#services")} className="hover:text-[#FF5A00] transition-colors" data-testid="footer-link-automations">{t("footer.automations")}</a></li>
                <li><a href="#services" onClick={scrollToHash("#services")} className="hover:text-[#FF5A00] transition-colors" data-testid="footer-link-social">{t("footer.social")}</a></li>
              </ul>
            </div>
            <div>
              <p className="text-xs uppercase tracking-widest text-neutral-500 mb-5">{t("footer.company")}</p>
              <ul className="space-y-3 text-sm text-neutral-400">
                <li><a href="#why-us" onClick={scrollToHash("#why-us")} className="hover:text-[#FF5A00] transition-colors" data-testid="footer-link-why-us">{t("footer.whyus")}</a></li>
                <li><a href="#environment" onClick={scrollToHash("#environment")} className="hover:text-[#FF5A00] transition-colors" data-testid="footer-link-environment">{t("footer.environment")}</a></li>
                <li><a href="#contact" onClick={scrollToHash("#contact")} className="hover:text-[#FF5A00] transition-colors" data-testid="footer-link-contact">{t("footer.contact")}</a></li>
              </ul>
            </div>
          </div>
          <button
            onClick={() => window.__lenis?.scrollTo(0)}
            className="self-start group flex items-center gap-2 border border-white/20 px-5 py-2.5 rounded-full text-sm hover:border-[#FF5A00] hover:text-[#FF5A00] transition-colors duration-300"
            data-testid="footer-back-to-top"
          >
            {t("footer.backToTop")}
            <ArrowUp className="w-4 h-4 transition-transform duration-300 group-hover:-translate-y-0.5" />
          </button>
        </div>

        <p className="font-syne font-bold text-[13vw] md:text-[18vw] leading-[0.8] text-outline select-none text-center" aria-hidden="true">
          FENRION
        </p>

        <div className="flex flex-col md:flex-row justify-between gap-4 mt-16 pt-8 border-t border-white/10 text-xs text-neutral-600">
          <p data-testid="footer-copyright">&copy; {new Date().getFullYear()} Fenrion AI. {t("footer.rights")}</p>
          <p>{t("footer.built")}</p>
        </div>
      </div>
    </footer>
  );
}
